import anime from "animejs";
import { WIN_CATEGORIES } from "./settings";

export const animateTextCounter = (
  targetRef,
  startValue,
  endValue,
  duration,
  formatCallback,
  onComplete
) => {
  let animation = null;

  // Function to check if the targetRef is available before starting animation
  const waitForElement = (callback) => {
    if (targetRef.current) {
      callback();
    } else {
      requestAnimationFrame(() => waitForElement(callback));
    }
  };

  // Function to start the animation
  const startAnimation = () => {
    const obj = { value: startValue };

    animation = anime({
      targets: obj,
      value: endValue,
      duration: duration,
      easing: "linear",
      update: () => {
        if (!targetRef.current) return; // Ensure the element is still available

        const formattedValue = formatCallback
          ? formatCallback(Math.floor(obj.value))
          : Math.floor(obj.value).toString();

        if (targetRef.current?.text !== undefined) {
          targetRef.current.text = formattedValue;
        }
      },
      complete: () => {
        if (!targetRef.current) return;

        const finalValue = formatCallback
          ? formatCallback(endValue)
          : endValue.toString();

        if (targetRef.current?.text !== undefined) {
          targetRef.current.text = finalValue;
        }

        if (onComplete) onComplete();
      },
    });
  };

  // Start checking for target element availability
  waitForElement(startAnimation);

  return () => {
    if (animation) {
      animation.pause();
      if (targetRef.current?.text !== undefined) {
        targetRef.current.text = formatCallback
          ? formatCallback(endValue)
          : endValue.toString();
      }
    }
  };
};

export const formatToCustomLocale = (value) => {
  return (value / 100).toLocaleString("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const calculateFontSize = (width, maxSize, minSize) => {
  if (width >= 1024) {
    return maxSize;
  } else {
    return minSize;
  }
};

export const getWinDuration = (winType) => {
  // Find the index of the current winType in WIN_CATEGORIES
  const targetIndex = WIN_CATEGORIES.findIndex(
    (category) => category.name === winType
  );

  if (targetIndex === -1) return 0; // Return 0 if winType is invalid

  // Sum durations (assumes durations are already in seconds)
  return WIN_CATEGORIES.slice(0, targetIndex + 1).reduce(
    (total, category) => total + Math.floor(category.duration),
    0
  );
};
